import Image from './Image';

const App = () => {
  return (
    <div class="container">
      <Image />
    </div>
  );
};

export default App;
